import { Login, YSLogin } from "@/api/users.api";
import Cookies from "js-cookie";

const fn = {
  SET_USER_DETAIL: "SET_USER_DETAIL",
  LOGOUT: "LOGOUT"
};

const state = {
  token: Cookies.get("uid") || "",
  user: {},
  inHour: 1/24,
};

// getters
const getters = {
  isLoggedIn: state => !!state.token
};

// actions
const actions = {
  async Login({ commit }, payload) {
    try {
      let resp = await Login(payload);
      if (resp.data.token && resp.data.user) {
        Cookies.set("uid", resp.data.token, { expires: state.inHour });
        Cookies.set("user", JSON.stringify(resp.data.user), { expires: state.inHour });
        commit(fn.SET_USER_DETAIL, resp.data);
      }
      return resp;
    } catch (err) {
      return err.response.status;
    }
  },
  async YSLogin({ commit, dispatch }, payload) {
    try {
      let resp = await YSLogin(payload);
      if (!resp.data.errormsg) {
        let data = resp.data;
        Cookies.set("uid", resp.data.token, { expires: state.inHour });
        Cookies.set("user", JSON.stringify(resp.data.user), { expires: state.inHour });
        commit(fn.SET_USER_DETAIL, data);
      } else {
        Cookies.remove("uid");
        Cookies.remove("user");
        commit(fn.LOGOUT);
        return 401;
      }
    } catch (err) {
      Cookies.remove("uid");
      Cookies.remove("user");
      commit(fn.LOGOUT);
      return 401;
    }
  },

  async Logout({ commit }) {
    Cookies.remove("uid");
    Cookies.remove("user");
    commit(fn.LOGOUT);
  },

  async renewCookie() {
    Cookies.set("uid", state.token, { expires: state.inHour });
    Cookies.set("user", state.user, { expires: state.inHour });
  }
};

// mutations
const mutations = {
  [fn.SET_USER_DETAIL](state, payload) {
    state.token = payload.token;
    state.user = payload.user;
  },
  [fn.LOGOUT](state, payload) {
    state.token = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
